import Layout from "@/layouts/layout";
import PageHeading from "@/components/layout/PageHeading";
import Panel from "@/components/ui/Panel";
import EmptyState from "@/components/ui/EmptyState";
import { ButtonLink } from "@/components/ui/Button";
import RsvpForm from "@/components/events/RsvpForm";
import type { SatelliteEvent } from "@/interfaces/satellite_event";

interface Prefill {
  name: string | null;
  email: string | null;
  birth_month: number | null;
  birth_year: number | null;
}

// One form for people who arrived from the landing page without a city in mind.
// It posts to the same endpoint an event page's form does, so capacity, the
// age window and the signup checks are all still the server's call.
export default function NewRsvp({
  events,
  rsvps_open,
  age_range,
  heard_about_options,
  prefill,
}: {
  events: SatelliteEvent[];
  rsvps_open: boolean;
  age_range: { min: number; max: number };
  heard_about_options: string[];
  prefill: Prefill;
}) {
  return (
    <Layout>
      <div className="flex flex-col gap-6">
        <PageHeading
          title="Sign up for a Boba Bash"
          subtitle="Pick a city below. You don't need an account."
          actions={
            <ButtonLink href="/events" variant="secondary">
              Browse every city
            </ButtonLink>
          }
        />

        {!rsvps_open ? (
          <Panel title="rsvp.form">
            <EmptyState
              title="Sign-ups aren't open yet"
              description="Sign-ups aren't open yet. The cities are already up if you want to see which one is nearest."
            />
          </Panel>
        ) : events.length === 0 ? (
          <Panel title="rsvp.form">
            <EmptyState
              title="No dates are public yet"
              description="No city has a date locked in yet. They show up here as soon as they do."
            />
          </Panel>
        ) : (
          <RsvpForm
            events={events}
            ageRange={age_range}
            heardAboutOptions={heard_about_options}
            prefill={prefill}
          />
        )}
      </div>
    </Layout>
  );
}
